import { createAsyncThunk } from '@reduxjs/toolkit';
import { uniq } from 'lodash';
import { getUsers } from 'store/chat/services/getUsers';
import fetchFile from 'utils/fetchFile';

export const loadChatUsers = createAsyncThunk(
  'chat/loadUsers',
  async ({ userIds }, { dispatch, getState }) => {
    const uniqueUserIds = uniq(userIds);
    const state = getState();
    const { allUsers } = state.chatSlice;

    // First, collect users from allUsers that already exist
    const users = {};
    const missingUserIds = [];

    for (const userId of uniqueUserIds) {
      if (allUsers[userId]) {
        // User already exists in allUsers, use it
        users[userId] = allUsers[userId];
      } else {
        // User not found, need to load it
        missingUserIds.push(userId);
      }
    }

    // Only fetch users that aren't in allUsers
    if (missingUserIds.length > 0) {
      const response = await getUsers(missingUserIds);

      for (const user of response.users) {
        let imageSrc = null;
        if (user.image) {
          imageSrc = await fetchFile(`thumbs/${user.image.key}`);
        }
        users[user.id] = {
          ...user,
          image: imageSrc,
        };
      }
    }

    return users;
  }
);
